import { useState } from "react";
import { formatInstagramTime } from "utils/helpers";

interface CommentMetaProps {
    likes: number;
    repliesCount?: number;
    onReply?: () => void;
    onReplyPrivately?: () => void;
    onDelete?: (resetDeletingState?: () => void) => void,
    timestamp: string,
}

const CommentMeta = ({
    likes,
    repliesCount,
    onReply,
    onReplyPrivately,
    onDelete,
    timestamp,
}: CommentMetaProps) => {

    const [deleting, setDeleting] = useState(false);

    return (
        <div className="comment-meta">
            {
                (likes > 0) &&
                <span>{likes} likes</span>
            }
            <button onClick={onReply}>Reply</button>
            <button onClick={onReplyPrivately}>Reply privately</button>
            <span>{formatInstagramTime(timestamp)}</span>
            {((repliesCount ?? 0) > 0) ? <span>{repliesCount} replies</span> : null}
            <button
                onClick={() => {
                    setDeleting(true);
                    onDelete?.(() => {
                        setDeleting(false);
                    })
                }}
                disabled={deleting}
                className="delete-btn"
            >
                {deleting ? (
                    <span className="spinner-border text-muted fs-6" style={{width: '16px', height:'16px', borderWidth: '1px'}}></span>
                ) : (
                    <span className="mdi mdi-delete-outline fs-6" />
                )}
            </button>
        </div>
    );
};


export default CommentMeta;